import { queryOptions } from '@tanstack/react-query'

import { fetchPackageCategories } from '../api'
import { packageCategoriesQueryKeys } from '../query-keys'

/**
 * Select用の荷姿一覧のQueryOptionsを返す
 * データは全件取得
 */
export const getPackageCategoriesSelectQueryOptions = (
  tenantKey: string,
  dcId?: number
) => {
  return queryOptions({
    queryKey: packageCategoriesQueryKeys.select(tenantKey, dcId),
    queryFn: async ({ signal }) => {
      const query = { enable: true, ...(dcId !== undefined ? { dcId } : {}) }

      // APIから全データを取得（現在の実装では上限なし）
      const { data } = await fetchPackageCategories(
        {
          tenantKey,
          query
        },
        signal
      )
      return data
    }
  })
}
